<template>
  <el-main>
    <el-card shadow="hover" v-for="item in productList" :key="item.id">
      <i class="el-icon-upload"></i>
      <h3 class="title">{{ item.packageName }}</h3>
      <div class="desc">
        <div>{{ item.subject }}</div>
      </div>
      <router-link :to="{ path: '/system/value_added_services_details',query:{'packageSn': item.packageSn}}">
        <el-button class="yellow_btn">查看详情</el-button>
      </router-link>
    </el-card>
  </el-main>
</template>
<script>
  import {
    getProductList
  } from '@/api.js'
  import {
    mapState
  } from 'vuex'
  export default {
    name: "SystemSoftwarePurchase",
    data() {
      return {
        productList: [],

      }
    },
    created() {
      // this.getProductList(3, 1)
      this.getProductList(2, 2)
    },
    mounted() {},
    methods: {
      getProductList(appCategoryId,packageType) {
        getProductList({
          appCategoryId: appCategoryId,
          packageType: packageType
        }).then(res => {
          if (res.code == 0) {
            if(res.data.list){
              this.productList = this.productList.concat(res.data.list)
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    computed: {
      ...mapState({}),
    },
  }
</script>

<style scoped lang="scss">
  .el-main {
    display: flex;
    flex-wrap: wrap;
  }

  .el-card {
    position: relative;
    text-align: center;
    width: 300px;
    height: 400px;
    margin-top: 40px;
    margin-right: 40px;

    i {
      color: #333333;
      font-size: 90px;
    }

    .desc {
      text-align: left;
      color: rgb(170, 170, 170);
      text-align: center;
    }

    .el-button {
      width: 140px;
      position: absolute;
      left: calc(50% - 70px);
      bottom: 20px;

    }
  }
</style>